// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/comparison-exchange/comparison-exchange.component.scss
// module id = 204
// module chunks = 0